import { Ref, WatchStopHandle } from 'vue';

export default function useHDRoadModelLayer(
  mapInstance: LooseObject,
  layerInfo: Ref<MapLayer<HDRoadModelLayerConfig>>,
) {
  if (!layerInfo.value || !layerInfo.value.config || !JUE.model.HDRoadModel) return;

  const { id, styleId } = layerInfo.value.config;

  if (!id) return;

  let unwatchList: WatchStopHandle[] | null = [];

  let modelLayer = new JUE.model.HDRoadModel({
    id,
    map: mapInstance,
    styleId,
  });

  unwatchList.push(watch(() => layerInfo.value.config.id, () => {
    modelLayer?.unmount();
    useHDRoadModelLayer(mapInstance, layerInfo);
  }));

  unwatchList.push(watch(() => layerInfo.value.config.styleId, (newVal) => {
    modelLayer.setStyleId(newVal);
  }));

  modelLayer.unmount = (): void => {
    modelLayer?.destroy();
    modelLayer = null;
    unwatchList?.forEach(unwatch => unwatch());
    unwatchList = null;
  };

  return modelLayer;
}
